export function exhaustiveCheck(x: any): never {
  throw new Error(`Unhandled case ${x}`);
}
